import * as SolidIcons from "@/icons/solid";

const CustomPlaceholder = (props) => {
	let { children, className, cx, getStyles, innerRef, innerProps, data } = props;

	const styles = getStyles("placeholder", props);

	const Icon = !data ? SolidIcons["MagnifyingGlassIcon"] : data?.icon ? SolidIcons[data.icon] : null;

	return (
		<div
			style={{
				...styles,
			}}
			className={cx(
				{
					placeholder: true,
				},
				className,
                "flex items-center",
			)}
			ref={innerRef}
			{...innerProps}
		>
			{Icon && <Icon className="h-8 w-8 mr-3" />}
			<div>{children}</div>
		</div>
	);
};

export { CustomPlaceholder };
